import { useEffect, useState } from "react";
import { api } from "./api";

/** Loads categories from the API once. Returns {categories, byslug, loading}. */
export function useCategories() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/categories")
      .then((res) => {
        if (cancelled) return;
        setCategories(res.data || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
    return () => {
      cancelled = true;
    };
  }, []);

  const byslug = {};
  for (const c of categories) byslug[c.slug] = c;

  return { categories, byslug, loading };
}
